<style></style>

<template>
    <div style="cursor: pointer;" class="mb-2 how-to-video" tabindex="0" @click="showModal = !showModal" @keydown.enter="showModal = !showModal">
        <span class="icon-video"></span>
        <a class="link-lighter"style="color:#4d8ab7" data-toggle="modal" data-target="#video-modal" @click="showVideo">
            Watch the How-To Video
        </a>
    </div>
</template>

<script>
    import { mapWritableState } from 'pinia'
    import { useMaterialsStore } from './materials/store.js';

    export default {
        props: {
            video: {
                type: Object,
                default: () => {
                    return {
                        title: 'Go NAPSACC How-To Video: 5 Steps',
                        assessmentURL: 'https://www.youtube.com/embed/OaLpKOVvMe8?ecver=2&modestbranding=1&autoplay=0&showinfo=0&enablejsapi=1&rel=0'
                    }
                }
            }
        },
        components: {
        },
        data() {
            return {
                showModal: false
            }
        },
        methods: {
            showVideo() {
                this.currentVideo = this.video;
            }
        },
        computed: {
            ...mapWritableState(useMaterialsStore, {
                currentVideo: 'video'
            }),
        }
}
</script>